import { getDryingBeds } from '@/network/api.service';
import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const initialState = {
  varietalList: null,
  agentList: null,
  dryingBeds: null,
};

const actions = (set, get) => ({
  setVarietalList: varietalList => set({ varietalList }),
  setAgentList: agentList => set({ agentList }),
  setLoading: loading => set({ loading }),
  getVarietalList: () => {
    return get().varietalList;
  },
  getAgentList: () => {
    return get().agentList;
  },

  // Drying Beds
  getDryingBeds: () => get().dryingBeds,
  fetchDryingBeds: async () => {
    try {
      const { data } = await getDryingBeds();
      set({ dryingBeds: data?.data || [] });
    } catch (error) {
      console.error('fetchDryingBeds failed:', error);
      set({ dryingBeds: [] });
    }
  },
});

// export const useMasterStore = create(
//   devtools(
//     (set, get) => ({
//       ...initialState,
//       ...actions(set, get),
//     }),
//     { name: 'MasterStore' }
//   )
// );

export const useMasterStore = create(
  devtools(
    persist(
      (set, get) => ({
        ...initialState,
        ...actions(set, get),
      }),
      {
        name: 'master-storage',
        partialize: state => ({
          agentList: state.agentList, // Only persist agentList
        }),
      }
    ),
    { name: 'MasterStore' }
  )
);
